<template>
  <!-- eslint-disable vue/max-attributes-per-line -->
  <section class="media-buying media-buying-loader" :data-name="computedName">
    <template v-if="computedName === 'channels'">
      <!-- vue3-migration -- отсутствует компонент для slot="head" -->
      <div class="head-wrap">
        <div class="!tw-justify-between !tw-flex ml-8 mr-8 level-0">
          <div class="!tw-flex level-1">
            <div class="!tw-flex level-2">
              <Skeleton height="12px" width="163px" class="mr-12 mt-10 mb-0" />
            </div>
            <div class="!tw-flex level-2">
              <Skeleton height="34px" width="200px" class="mr-12" />
              <Skeleton height="34px" width="150px" class="mr-12" />
            </div>
          </div>
          <div class="!tw-flex level-1">
            <div class="!tw-flex level-2 ml-8">
              <Skeleton height="34px" width="153px" />
            </div>
            <div class="!tw-flex level-2 ml-12">
              <div>
                <Skeleton height="34px" width="80px" class="mr-12" />
                <Skeleton height="34px" width="212px" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Skeleton width="auto" class="mb-24 ml-24 mr-24" />
    </template>
    <template v-if="computedName === 'campaigns'">
      <!-- vue3-migration -- отсутствует компонент для slot="head" -->
      <div class="head-wrap">
        <div class="ml-10 mr-10">
          <Skeleton height="34px" width="90px" class="mr-12" />
          <Skeleton height="12px" width="200px" />
        </div>
        <ElDivider class="mt-12 mb-12 ml-10 mr-10" />
        <div class="!tw-justify-between !tw-flex ml-8 mr-8 level-0">
          <div class="!tw-flex level-1">
            <div class="!tw-flex level-2">
              <Skeleton height="12px" width="163px" class="mr-12 mt-10 mb-0" />
            </div>
            <div class="!tw-flex level-2">
              <Skeleton height="34px" width="200px" class="mr-12" />
              <Skeleton height="34px" width="150px" class="mr-12" />
            </div>
          </div>
          <div class="!tw-flex level-1">
            <div class="!tw-flex level-2 ml-8">
              <Skeleton height="34px" width="153px" />
            </div>
            <div class="!tw-flex level-2 ml-12">
              <div>
                <Skeleton height="34px" width="80px" class="mr-12" />
                <Skeleton height="34px" width="212px" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Skeleton width="auto" class="mb-24 ml-24 mr-24" />
    </template>
    <template v-if="computedName === 'campaign_details'">
      <!-- vue3-migration -- отсутствует компонент для slot="head" -->
      <div class="head-wrap">
        <div class="!tw-justify-between !tw-flex ml-10 mr-10">
          <div>
            <Skeleton height="34px" width="90px" class="mr-12 mt-10" />
            <Skeleton height="12px" width="200px" class="mt-10" />
          </div>
          <div>
            <Skeleton height="34px" width="138px" class="mt-10" />
            <Skeleton height="34px" width="138px" class="ml-12 mt-10" />
          </div>
        </div>
        <Skeleton height="12px" width="303px" class="ml-10 mt-22 mb-10" />
        <ElDivider class="mt-12 mb-12 ml-10 mr-10" />
        <div class="ml-8 mr-8 level-0">
          <Skeleton height="38px" width="96px" class="mt-12 mr-32" />
          <Skeleton height="38px" width="96px" class="mt-12 mr-32" />
          <Skeleton height="38px" width="96px" class="mt-12 mr-32" />
          <Skeleton height="38px" width="96px" class="mt-12 mr-32" />
          <Skeleton height="38px" width="96px" class="mt-12" />
        </div>
      </div>
      <Skeleton width="auto" class="ml-24 mr-24 mb-24 mt-10" />
    </template>
  </section>
</template>

<script>
import Skeleton from '@/components/Skeleton';

export default {
  props: {
    name: String,
  },
  computed: {
    computedName() {
      const name = this.name || '';
      return name.toLowerCase();
    }, 
  },
  components: {
    Skeleton,
  },
};
</script>

<style lang="scss" scoped>
// vue3-migration -- '@/assets/theme/common-page-styles.scss'
// @import 'src/assets/theme/default/mediabuying/mediabuying';
</style>
